






































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
@Component
export default class storeinfomanagecreateoredit extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: undefined }) agentId: number;
  @Prop() id: number;
  @Prop() rate: number;
  merchants = [];
  types = [];
  models = [];
  mervalue = ''
  disabled = true
  unBind = false
  get areaProx() {
    return new proxy.ChannelServiceProxy();
  }
  checkbind(e) {
    this.models.map((x) => {
      x.m_isbind = e;
    });
    this.$forceUpdate();
  }
  save() {
    let req = new proxy.BindMerchantChannelsInputDto();
    req.channelId = this.id;
    req.typeIds = this.types.map((x) => {
      return x.id;
    });
    req.merchantChannels = req.merchantChannels || [];
    req.unBind = this.unBind
    this.models.map((x) => {
      if (x.m_isbind) {
        let m = new proxy.MerchantChannelDto();
        m.channelId = req.channelId;
        m.channelTypeId = x.type_id;
        m.merchantId = x.m_id;
        req.merchantChannels.push(m);
      }

    });
    this.areaProx.bindMerchantChannels(req).then(() => {
      (this.$refs.roleForm as any).resetFields();
      this.$Notice.success({ title: "保存成功" });
      this.$emit("save-success");
      this.$emit("input", false);
    });
  }
  unBindingLoss() {
    this.models.map(x => {
      if (x.m_rate < this.rate) {
        x.m_isbind = false
      }
    })
  }
  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      this.unBind = false
    } else {
      this.mervalue = ''
      let req = new proxy.MerchantSimpleInputDto();
      new proxy.MerchantServiceProxy().queryAllList(req).then((x) => {
        this.merchants = x;
        new proxy.ChannelTypeServiceProxy()
          .queryChannelTypesByChannelId(this.id)
          .then((x) => {
            this.types = x;

            let req2 = new proxy.QueryMerchantChannelTypesByTypeIdsInputDto();
            req2.typeIds = this.types.map((x) => {
              return x.id;
            });
            req2.channelId = this.id;
            new proxy.MerchantServiceProxy()
              .queryMerchantChannelTypesByTypeIds(req2)
              .then((x) => {
                let arr = [];
                this.types.map((t) => {
                  this.merchants.map((mer) => {
                    let m = {} as any;
                    m.type_id = t.id;
                    m.type_Name = t.name;
                    m.type_isEnable = t.isEnable;
                    m.type_rate = t.rate;
                    m.type_code = t.code;
                    m.m_mid = mer.mid;
                    m.m_id = mer.id;
                    m.m_name = mer.merchantName;
                    m.m_status = mer.status;
                    let t_mer = x.merchantChannelTypes.find(
                      (p) => p.channelTypeId == t.id && p.merchantId == mer.id
                    );
                    m.m_isopentype = false; //是否开通产品
                    m.m_rate = 0;
                    if (t_mer) {
                      m.m_isopentype = true;
                      m.m_rate = t_mer.rate;
                    }
                    let c_mer = x.merchantChannels.find(
                      (p) => p.channelTypeId == t.id && p.merchantId == mer.id
                    );
                    m.m_isbind = false;
                    if (c_mer) {
                      m.m_isbind = true;
                    }
                    arr.push(m);
                  });
                });

                this.models = arr.sort((a, b) => a.m_rate - b.m_rate);
                this.disabled = false
              });
          });
      });
    }
  }
  roleRule = {};
}
